class BankSecrecyDeclarationModalController {
	constructor(BaseService) {
		'ngInject';
		'ngInit';
		this.baseService = BaseService;
		this.bankSecretAcceptedCheckbox = false;
		this.modalIsOpen = true;

	}

	saveBankSecretAcceptance(){
		if(this.bankSecretAcceptedCheckbox){
			this.showLoader();
			this.modalIsOpen = false;

			this.saveBankSecretAcceptanceRest()
				.then(() => {
					window.location.reload();
				})
				.catch(() => {
					this.hideLoader();
					this.modalIsOpen = true;
				});

		}

	}

	saveBankSecretAcceptanceRest () {
		return this.baseService.createPromise('acceptBankSecrecy', {})
	}


}

export default BankSecrecyDeclarationModalController;
